import { render, staticRenderFns } from "./LibraryUsersItem.vue?vue&type=template&id=6b0b9cb2&"
import script from "./LibraryUsersItem.vue?vue&type=script&lang=ts&"
export * from "./LibraryUsersItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VCheckbox,VImg})
